<mat-dialog-content>
  <div class="row">
    <div class="col-12">
      <h1 mat-dialog-title>Replace document addresses</h1>
      <p>Replace the address on documents linked to the <b>source address</b> with the <b>destination address</b>. The <b>source address</b> will be removed. <br>
        Change direction by clicking the arrow button.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-5 align-content-center">
      <ng-container [ngTemplateOutlet]="addresses[0].main ? destinationAddress : sourceAddress"></ng-container>
      <mat-form-field>
        <mat-label>ExternalId (SAP)</mat-label>
        <input matInput disabled
               [value]="addresses[0].address?.ExternalRelationId ? addresses[0].address?.ExternalRelationId : 'No Id'">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Street and number</mat-label>
        <input matInput disabled
               [value]="addresses[0].address?.Street + ' ' + addresses[0].address?.Number + ' ' + (addresses[0].address?.BusNumber ? addresses[0].address?.BusNumber : '')">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Postal code and city</mat-label>
        <input matInput disabled
               [value]="addresses[0].address?.Postcode + ' ' + addresses[0].address?.City">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Type</mat-label>
        <input matInput disabled [value]="addresses[0].address?.Type?.Value">
      </mat-form-field>
    </div>
    <div class="col-md-2" style="text-align: center; margin-top: 25px">
      <button type="submit" mat-icon-button (click)="setMainAddress()" [disabled]="mergeFinished || mergeLoading">
        <mat-icon style="transform: scale(200%); margin: 5px">settings_ethernet</mat-icon>
      </button>
      <p class="msgbox bg-success p-3 w-100" *ngIf="mergeFinished"><b>Destination address</b> has been replaced with the <b>source address</b>, <b>source address</b> has been deleted.</p>
    </div>
    <div class="col-md-5 align-content-center">
      <ng-container [ngTemplateOutlet]="addresses[1].main ? destinationAddress : sourceAddress"></ng-container>
      <mat-form-field>
        <mat-label>AddressId</mat-label>
        <input matInput disabled
               [value]="addresses[1].address?.ExternalRelationId ? addresses[1].address?.ExternalRelationId : 'No Id'">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Street and number</mat-label>
        <input matInput disabled
               [value]="addresses[1].address?.Street + ' ' + addresses[1].address?.Number + ' ' + (addresses[1].address?.BusNumber ? addresses[1].address?.BusNumber : '')">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Postal code and city</mat-label>
        <input matInput disabled
               [value]="addresses[1].address?.Postcode + ' ' + addresses[1].address?.City">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Type</mat-label>
        <input matInput disabled [value]="addresses[1].address?.Type?.Value">
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="fill-remaining-space"></div>
  <button mat-raised-button (click)="close()">Close</button>
  <app-button [disabled]="mergeFinished" [isLoading]="mergeLoading" (click)="merge();" [title]="'Merge'">
  </app-button>
</mat-dialog-actions>

<ng-template #destinationAddress>
  <p class="msgbox bg-info p-3 w-100">Destination address</p>
</ng-template>
<ng-template #sourceAddress>
  <p class="msgbox bg-warning p-3 w-100">Source address <span *ngIf="mergeFinished"> (removed)</span></p>
</ng-template>
